import { render, staticRenderFns } from "./AmbassadorWithdrawalRequestModal.vue?vue&type=template&id=7ec74db8&"
import script from "./AmbassadorWithdrawalRequestModal.vue?vue&type=script&lang=js&"
export * from "./AmbassadorWithdrawalRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports